module.exports = __webpack_public_path__ + "media/en_gb_s2_Keeton.4b2ce5d6.mp3";